import './index.scss';
import { RESOURCE_MEDIA_TYPE, ResourceType } from '@umu/umu-types';
import React from 'react';
import UMUImg from '../../../@UMUImg/UMUImg';
import { Iconfont } from '@umu/umu-design';
interface IProps {
    className?: string;
    isALlowDelete: boolean;
    list: IResourceInfo[];
    onUpdateResourceList: (list: IResourceInfo[]) => void;
}
const QuestionResource = (props: IProps) => {
    const { className = '', list, onUpdateResourceList } = props;
    const onDelImg = (index: number) => {
        const newList = list.filter((_item, i) => i !== index);
        onUpdateResourceList(newList);
    };
    const renderResourceItem = (item: IResourceInfo, index: number) => {
        const { resource_type } = item;
        switch (resource_type) {
            case RESOURCE_MEDIA_TYPE.TYPE_HOMEWORK_MULTI_EVAL_IMAGE:
                return (
                    <div className="image-info">
                        <UMUImg src={item.resource_data.url} clsName="option-img" />
                        <Iconfont type="Delete2" className="img-del-icon view-hide" onClick={() => onDelImg(index)} />
                    </div>
                );
            case ResourceType.LIVE_STREAM:
                return <div />;
            default:
                return null;
        }
    };
    const renderResourceList = () => {
        return list.map((item, index) => {
            return (
                <li key={`resource-${index}`} className="option-resource-item">
                    {renderResourceItem(item, index)}
                </li>
            );
        });
    };
    return <ul className={`option-resource-list ${className}`}>{renderResourceList()}</ul>;
};
export { QuestionResource };
